import React from "react";
import { useState, useEffect, useContext, useRef } from "react";
import { data, useNavigate } from "react-router-dom";
import styled from "styled-components";
import TitleBox from "./TitleBox";
import EditorBox from "./EditorBox";
import TagBox from "./TagBox";
import PublishBox from "./PublishBox";
import ModifyBox from "./ModifyBox";
import client from "../../api/WookAxios";
import PostContext from "../PostContext";
import log from "loglevel";

const WriteFrame = styled.div`
  width: 100%;
  box-sizing: border-box;
  // background: yellow;
  padding-left: 1rem;
  padding-right: 1rem;
`;

const EditorBlock = styled.div`
  padding-top: 3rem;
  padding-bottom: 1rem;
  box-sizing: border-box;
  // background: gray;
`;

const WriteArea = () => {
  const { post, setPost } = useContext(PostContext);
  const mounted = useRef(false);
  const navigate = useNavigate();

  useEffect(() => {
    console.log('useEffect called');
    if (mounted.current) return;
    mounted.current = true;
    // setPost(post);
    console.log(post);
  }, []);

  const onPublish = async () => {
    const data = {
      title: post.title,
      content: post.content,
      // tags: post.tags,
    }

    console.log('publish data', data);

    try {
      const response = await client.sPost('/api/v1/posts/', data);
      console.log(response);
      navigate(`/posts/${response.data.id}`);
    } catch (e) {
      console.log(e);
    }
  };

  const onModify = async () => {
    const data = {
      title: post.title,
      content: post.content,
      tags: post.tags,
    }

    try {
      const response = await client.sPatch(`/api/v1/posts/${post.id}/`, data);
      console.log('modify data', response);
      navigate(`/posts/${response.data.id}`);
    } catch (e) {
      console.log(e);
    }
  };

  const onCancel = () => {
    const confirm = window.confirm('작성한 내용이 사라집니다. 정말 취소하겠습니까?');
    if (confirm) {
      navigate('/postlist');
    }
  };

  const go = async () => {
    try {
      const response = await client.get('/api/v1/media/images/post/tooth_original.png');
      console.log(response);
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <div className="WriteArea">
      <WriteFrame>
        <EditorBlock>
          <TitleBox value={post.title} setPost={setPost} />
          <EditorBox value={post.content} setPost={setPost} post={post} />
        </EditorBlock>
        {/* <TagBox tags={post.tags} setPost={setPost} /> */}
        
        {(post.modify ?
          <ModifyBox onModify={onModify} onCancel={onCancel} /> :
          <PublishBox onPublish={onPublish} onCancel={onCancel} />
        )}
      {/* <button onClick={go}>go</button> */}
      {/* {post.content} */}
      </WriteFrame>
    </div>
  );
};

export default WriteArea;
